import React from "react";

import styles from "./AboutUs.module.css";

import paper from "../assets/Light aboutus_img/Asset 17.webp";
import rock from "../assets/Light aboutus_img/Asset 16.webp";
import tboard from "../assets/Light aboutus_img/t-board.png";
import pillar1 from "../assets/Light aboutus_img/Asset 21.webp";
import pillar2 from "../assets/Light aboutus_img/Asset 20.webp";
import pillar3 from "../assets/Light aboutus_img/Asset 18.webp";
import small_rock from "../assets/Light aboutus_img/Asset 19.webp";
import big_rock from "../assets/Light aboutus_img/Asset 15.webp";
import l_grass from "../assets/Light aboutus_img/Asset 12.webp";
import r_grass from "../assets/Light aboutus_img/Asset 13.webp";
import intro from "../assets/Light aboutus_img/Intro.mp4";
import side from "../assets/Light aboutus_img/Asset 24.webp";
import frame from "../assets/Light aboutus_img/Asset 22.webp";
import { Helmet } from "react-helmet-async";
// import grass from "../assets/Light aboutus_img/Asset +25.webp";

// import Footer from "./Footer";
import { useRef, useState, useEffect } from "react";



function AboutUs() {

    const videoRef = useRef(null);
    const [playing, setPlaying] = useState(false);
    const [showControls, setShowControls] = useState(false);

    const handlePlayPause = () => {
        if (!videoRef.current) return;

        if (videoRef.current.paused) {
            videoRef.current.play();
            setPlaying(true);
        } else {
            videoRef.current.pause();
            setPlaying(false);
        }
    };

    // for mobile
    const [currentSlide, setCurrentSlide] = useState(0);
    const [isMobile, setIsMobile] = useState(false);

    useEffect(() => {
        const checkMobile = () => {
            setIsMobile(window.innerWidth <= 575.98);
        };

        checkMobile();
        window.addEventListener('resize', checkMobile);

        return () => window.removeEventListener('resize', checkMobile);
    }, []);

    const nextSlide = () => {
        setCurrentSlide((prev) => (prev + 1) % 3);
    };

    const prevSlide = () => {
        setCurrentSlide((prev) => (prev - 1 + 3) % 3);
    };

    const goToSlide = (index) => {
        setCurrentSlide(index);
    };

    // Touch handling for swipe
    const [touchStart, setTouchStart] = useState(0);
    const [touchEnd, setTouchEnd] = useState(0);

    const handleTouchStart = (e) => {
        setTouchStart(e.touches[0].clientX);
    };

    const handleTouchMove = (e) => {
        setTouchEnd(e.touches[0].clientX);
    };

    const handleTouchEnd = () => {
        if (touchStart - touchEnd > 75) {
            nextSlide();
        }
        if (touchStart - touchEnd < -75) {
            prevSlide();
        }
    };


    return (
        <>
       <Helmet>
  <title>About Us - Jungle Morals</title>

  <meta
    name="description"
    content="Jungle Morals creates joyful stories, songs, and interactive videos that teach kids kindness, honesty, and empathy - For Kids’ Joy and Parents’ Peace of Mind."
  />

  <link
    rel="canonical"
    href="https://www.junglemorals.com/about"
  />

  <meta property="og:title" content="About Us - Jungle Morals" />
<meta property="og:description" content="Jungle Morals creates joyful stories, songs, and interactive videos that teach kids kindness, honesty, and empathy." />
<meta property="og:url" content="https://www.junglemorals.com/about" />
<meta property="og:type" content="website" />
<meta property="og:image" content="https://www.junglemorals.com/static/media/Asset%2017.0e20cfe56792845a97e2.webp" />

<meta name="twitter:card" content="summary_large_image" />
<meta name="twitter:title" content="About Us - Jungle Morals" />
<meta name="twitter:description" content="Jungle Morals creates joyful stories, songs, and interactive videos that teach kids kindness, honesty, and empathy." />
<meta name="twitter:image" content="https://www.junglemorals.com/static/media/Asset%2017.0e20cfe56792845a97e2.webp" />

<meta name="robots" content="index, follow" />

  {/* Schema Markup */}
  <script type="application/ld+json">
    {JSON.stringify({
      "@context": "https://schema.org",
      "@graph": [
        {
          "@type": "Organization",
          "@id": "https://www.junglemorals.com/#organization",
          name: "Jungle Morals",
          url: "https://www.junglemorals.com/",
          logo: {
            "@type": "ImageObject",
            url: "https://www.junglemorals.com/static/media/Asset.4660813ebac538e8b202.webp"
          }
        },
        {
          "@type": "WebSite",
          "@id": "https://www.junglemorals.com/#website",
          url: "https://www.junglemorals.com/",
          name: "Jungle Morals",
          publisher: {
            "@id": "https://www.junglemorals.com/#organization"
          }
        },
        {
          "@type": "WebPage",
          "@id": "https://www.junglemorals.com/about#webpage",
          url: "https://www.junglemorals.com/about",
          name: "About Us - Jungle Morals",
          description:
            "Jungle Morals creates joyful stories, songs, and interactive videos that teach kids kindness, honesty, and empathy.",
          isPartOf: {
            "@id": "https://www.junglemorals.com/#website"
          },
          about: {
            "@id": "https://www.junglemorals.com/#organization"
          },
          primaryImageOfPage: {
            "@type": "ImageObject",
            url: "https://www.junglemorals.com/static/media/Asset%2017.0e20cfe56792845a97e2.webp"
          }
        },
        {
          "@type": "BreadcrumbList",
          "@id": "https://www.junglemorals.com/about#breadcrumb",
          itemListElement: [
            {
              "@type": "ListItem",
              position: 1,
              name: "Home",
              item: "https://www.junglemorals.com/"
            },
            {
              "@type": "ListItem",
              position: 2,
              name: "About Us",
              item: "https://www.junglemorals.com/about"
            }
          ]
        }
      ]
    })}
  </script>
</Helmet>
            <div className={styles.aboutpage}>

                <div className={styles.firstsec}>

                    <div className={styles.frame}>
                        <img src={r_grass} alt="Decorative vine border with leaves and flowers in corner frame design" srcset="" className={styles.rightgrass} />
                        <img src={frame} alt="Blank wooden frame for text or message display" srcset="" className={styles.videoframe} />
                        {/* <video width="100%" controls muted playsInline className={styles.video}>
                            <source src={intro} type="video/mp4" />
                        </video> */}
                        <div className={styles.videoContainer} onMouseEnter={() => setShowControls(true)} onMouseLeave={() => setShowControls(false)}>
                            <video
                                ref={videoRef}
                                playsInline
                                preload="auto"
                                className={styles.video}
                                onClick={handlePlayPause}
                                onPlay={() => {
                                    setPlaying(true);
                                    window.dispatchEvent(new Event("pause-bg-music"));
                                }}
                                onPause={() => {
                                    setPlaying(false);
                                    window.dispatchEvent(new Event("resume-bg-music"));
                                }}
                                onEnded={() => {
                                    setPlaying(false);
                                    window.dispatchEvent(new Event("resume-bg-music"));

                                    // Video ko beginning pe reset karo
                                    if (videoRef.current) {
                                        videoRef.current.currentTime = 0;
                                    }
                                }}
                            >
                                <source src={intro} type="video/mp4" />
                            </video>

                            {!playing && (
                                <div className={styles.playBtn} onClick={handlePlayPause}>
                                    <svg xmlns="http://www.w3.org/2000/svg" width="40" height="40" viewBox="0 0 24 24" fill="white" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" className="lucide lucide-play-icon lucide-play">
                                        <path d="M5 5a2 2 0 0 1 3.008-1.728l11.997 6.998a2 2 0 0 1 .003 3.458l-12 7A2 2 0 0 1 5 19z" />
                                    </svg>
                                </div>
                            )}
                            {playing && showControls && (
                                <div className={styles.pauseBtn} onClick={handlePlayPause}>
                                    <svg xmlns="http://www.w3.org/2000/svg" width="40" height="40" viewBox="0 0 24 24" fill="white" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" className="lucide lucide-pause-icon lucide-pause">
                                        <rect x="14" y="3" width="5" height="18" rx="1" />
                                        <rect x="5" y="3" width="5" height="18" rx="1" />
                                    </svg>
                                </div>
                            )}
                        </div>
                        <img src={l_grass} alt="Decorative vine border with leaves and flowers forming corner frame" srcset="" className={styles.leftgrass} />
                    </div>


                    <div className={styles.paper}>

                        <img src={paper} alt="Blank parchment scroll for story text or message display" className={styles.textpaper} />
                        <img src={rock} alt="Small rock with grass and leaves in a jungle setting" className={styles.rockstone} />
                        <img src={side} alt="Green grassy hill with small white flowers in a cartoon landscape" className={styles.sidegrass} />
                        <p className={`font-brandon ${styles.text}`}>
                            At <strong className={styles.strongtext}>Jungle Morals,</strong> we believe every child<br />
                            deserves stories that make their<strong className={styles.strongtext}> hearts grow.</strong><br />
                            We create fun, engaging, research-backed<br />
                            content that nurtures emotional intelligence,<br />
                            <strong className={styles.strongtext}>kindness,</strong> and <strong className={styles.strongtext}> confidence</strong> in children.<br />
                            Through lovable characters, catchy songs,<br />
                            and relatable stories, we help kids learn<br />
                            <strong className={styles.strongtext}>empathy, resilience, and responsibility—</strong><br />
                            while giving parents a safe, meaningful<br />
                            alternative to passive screen time.<br />
                            <strong className={styles.strongtext}>Jungle Morals</strong> reimagines the screen<br />
                            as a place where <strong className={styles.strongtext}> families can build</strong><br />
                            values together, spark conversations that<br />
                            matter, and connect through stories<br />
                            <strong className={styles.strongtext}> filled with warmth and purpose.</strong>
                        </p>
                    </div>

                </div>
                <div className={styles.secondsec}>
                    <img src={tboard} alt="Wooden signboard with vines and empty space for text or message" className={styles.tboard} />
                    <h1 className={`font-adventuring ${styles.tboardtext}`}>Brand Pillars</h1>

                    {isMobile ? (
                        <>
                            <div
                                className={styles.pillarsSlider}
                                onTouchStart={handleTouchStart}
                                onTouchMove={handleTouchMove}
                            // onTouchEnd={handleTouchEnd}
                            >
                                <div
                                    className={styles.pillarsTrack}
                                    style={{ transform: `translateX(-${currentSlide * 100}vw)` }}
                                >
                                    {/* Slide 1 - Core Values */}
                                    <div className={styles.pillarSlide}>
                                        <img src={pillar1} alt="classical stone pillar with carved details and green vines wrapped around it in a decorative jungle setting" className={styles.pillar1} />
                                        <h2 className={`font-adventuring ${styles.pillar1text1}`}>Core Values</h2>
                                        <h2 className={`font-brandon ${styles.pillar1text2}`}>
                                            <strong className={styles.strongtext}>Integrity -</strong><br />
                                            Honesty and<br />
                                            Moral clarity.
                                        </h2>
                                        <h2 className={`font-brandon ${styles.pillar1text3}`}>
                                            <strong className={styles.strongtext}>Empathy</strong> -<br />
                                            Kindness at the<br />
                                            heart of every<br />
                                            interaction.
                                        </h2>
                                        <h2 className={`font-brandon ${styles.pillar1text4}`}>
                                            <strong className={styles.strongtext}>Creativity</strong><br />
                                            Bold, imaginative<br />
                                            storytelling.
                                        </h2>
                                        <h2 className={`font-brandon ${styles.pillar1text5}`}>
                                            <strong className={styles.strongtext}>Inclusivity</strong> -<br />
                                            Diverse<br />
                                            characters,<br />
                                            cultures,<br />
                                            and situations.
                                        </h2>
                                        <h2 className={`font-brandon ${styles.pillar1text6}`}>
                                            <strong className={styles.strongtext}>Impact</strong> -<br />
                                            Entertainment<br />
                                            with educational<br />
                                            and social<br />
                                            benefits.
                                        </h2>
                                    </div>

                                    {/* Slide 2 - Personality */}
                                    <div className={styles.pillarSlide}>
                                        <img src={pillar2} alt="classical stone pillar with carved details and green vines wrapped around it in a decorative jungle setting" className={styles.pillar2} />
                                        <h2 className={`font-adventuring ${styles.pillar2text1}`}>Personality</h2>
                                        <h2 className={`font-brandon ${styles.pillar2text2}`}>
                                            <strong className={styles.strongtext}>Playful</strong><br />
                                            <strong className={styles.strongtext}>Teacher</strong> -<br />
                                            Wise but<br />
                                            approachable
                                        </h2>
                                        <h2 className={`font-brandon ${styles.pillar2text3}`}>
                                            <strong className={styles.strongtext}>Cheer-Leader</strong><br />
                                            Celebrates<br />
                                            every child's<br />
                                            potential
                                        </h2>
                                        <h2 className={`font-brandon ${styles.pillar2text4}`}>
                                            <strong className={styles.strongtext}>Adventurer</strong> -<br />
                                            Curious and<br />
                                            bold
                                        </h2>
                                        <h2 className={`font-brandon ${styles.pillar2text5}`}>
                                            <strong className={styles.strongtext}>Friend</strong><br />
                                            <strong className={styles.strongtext}>And Guide</strong>-<br />
                                            Relatable,<br />
                                            never preachy
                                        </h2>
                                        <h2 className={`font-brandon ${styles.pillar2text6}`}>
                                            <strong className={styles.strongtext}>Nurturer</strong> –<br />
                                            Calm,<br />
                                            comforting,<br />
                                            and emotionally<br />
                                            safe
                                        </h2>
                                    </div>

                                    {/* Slide 3 - The Purpose */}
                                    <div className={styles.pillarSlide}>
                                        <img src={pillar3} alt="classical stone pillar with carved details and green vines wrapped around it in a decorative jungle setting" className={styles.pillar3} />
                                        <h2 className={`font-adventuring ${styles.pillar3text1}`}>The Purpose</h2>
                                        <h2 className={`font-brandon ${styles.pillar3text2}`}>
                                            To <strong>inspire</strong> growing<br />
                                            young minds<br />
                                            through engaging,<br />
                                            <strong className={styles.strongtext}>value-driven</strong><br />
                                            content that<br />
                                            <strong className={styles.strongtext}>nurture empathy</strong>,<br />
                                            curiosity, and<br />
                                            positive<br />
                                            character traits<br />
                                            — <strong className={styles.strongtext}>building</strong> a<br />
                                            generation of<br />
                                            kind, confident<br />
                                            social responsible<br />
                                            individuals who<br />
                                            lead with <strong className={styles.strongtext}>courage</strong><br />
                                            and <strong className={styles.strongtext}>heart</strong> and<br />
                                            make the world<br />
                                            a better place.
                                        </h2>
                                    </div>
                                </div>
                            </div>

                            {/* Slider Dots */}
                            <div
                                className={`${styles.arrowNav} ${styles.leftArrow} ${currentSlide === 0 ? styles.hidden : ''}`}
                                onClick={prevSlide}
                            >
                                <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.5" strokeLinecap="round" strokeLinejoin="round">
                                    <path d="M15 18l-6-6 6-6" />
                                </svg>
                            </div>

                            {/* Right Arrow */}
                            <div
                                className={`${styles.arrowNav} ${styles.rightArrow} ${currentSlide === 2 ? styles.hidden : ''}`}
                                onClick={nextSlide}
                            >
                                <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.5" strokeLinecap="round" strokeLinejoin="round">
                                    <path d="M9 18l6-6-6-6" />
                                </svg>
                            </div>
                        </>
                    ) : (
                        <>
                            {/* Desktop View - Original Layout */}
                            <img src={pillar1} alt="classical stone pillar with carved details and green vines wrapped around it in a decorative jungle setting" className={styles.pillar1} />
                            <h2 className={`font-adventuring ${styles.pillar1text1}`}>Core Values</h2>
                            <h2 className={`font-brandon ${styles.pillar1text2}`}>
                                <strong className={styles.strongtext}>Integrity -</strong><br />
                                Honesty and<br />
                                Moral clarity.
                            </h2>
                            <h2 className={`font-brandon ${styles.pillar1text3}`}>
                                <strong className={styles.strongtext}>Empathy</strong> -<br />
                                Kindness at the<br />
                                heart of every<br />
                                interaction.
                            </h2>
                            <h2 className={`font-brandon ${styles.pillar1text4}`}>
                                <strong className={styles.strongtext}>Creativity</strong><br />
                                Bold, imaginative<br />
                                storytelling.
                            </h2>
                            <h2 className={`font-brandon ${styles.pillar1text5}`}>
                                <strong className={styles.strongtext}>Inclusivity</strong> -<br />
                                Diverse<br />
                                characters,<br />
                                cultures,<br />
                                and situations.
                            </h2>
                            <h2 className={`font-brandon ${styles.pillar1text6}`}>
                                <strong className={styles.strongtext}>Impact</strong> -<br />
                                Entertainment<br />
                                with educational<br />
                                and social<br />
                                benefits.
                            </h2>

                            <img src={pillar2} alt="classical stone pillar with carved details and green vines wrapped around it in a decorative jungle setting" className={styles.pillar2} />
                            <h2 className={`font-adventuring ${styles.pillar2text1}`}>Personality</h2>
                            <h2 className={`font-brandon ${styles.pillar2text2}`}>
                                <strong className={styles.strongtext}>Playful</strong><br />
                                <strong className={styles.strongtext}>Teacher</strong> -<br />
                                Wise but<br />
                                approachable
                            </h2>
                            <h2 className={`font-brandon ${styles.pillar2text3}`}>
                                <strong className={styles.strongtext}>Cheer-Leader</strong><br />
                                Celebrates<br />
                                every child's<br />
                                potential
                            </h2>
                            <h2 className={`font-brandon ${styles.pillar2text4}`}>
                                <strong className={styles.strongtext}>Adventurer</strong> -<br />
                                Curious and<br />
                                bold
                            </h2>
                            <h2 className={`font-brandon ${styles.pillar2text5}`}>
                                <strong className={styles.strongtext}>Friend</strong><br />
                                <strong className={styles.strongtext}>And Guide</strong>-<br />
                                Relatable,<br />
                                never preachy
                            </h2>
                            <h2 className={`font-brandon ${styles.pillar2text6}`}>
                                <strong className={styles.strongtext}>Nurturer</strong> –<br />
                                Calm,<br />
                                comforting,<br />
                                and emotionally<br />
                                safe
                            </h2>

                            <img src={pillar3} alt="classical stone pillar with carved details and green vines wrapped around it in a decorative jungle setting" className={styles.pillar3} />
                            <h2 className={`font-adventuring ${styles.pillar3text1}`}>The Purpose</h2>
                            <h2 className={`font-brandon ${styles.pillar3text2}`}>
                                To <strong>inspire</strong> growing<br />
                                young minds<br />
                                through engaging,<br />
                                <strong className={styles.strongtext}>value-driven</strong><br />
                                content that<br />
                                <strong className={styles.strongtext}>nurture empathy</strong>,<br />
                                curiosity, and<br />
                                positive<br />
                                character traits<br />
                                — <strong className={styles.strongtext}>building</strong> a<br />
                                generation of<br />
                                kind, confident<br />
                                social responsible<br />
                                individuals who<br />
                                lead with <strong className={styles.strongtext}>courage</strong><br />
                                and <strong className={styles.strongtext}>heart</strong> and<br />
                                make the world<br />
                                a better place.
                            </h2>
                        </>
                    )}

                    <img src={big_rock} alt="Green bush with small white flowers growing over a rock in a jungle setting" className={styles.big_rock} />
                    <img src={small_rock} alt="Small rock surrounded by yellow flowers and grass in a jungle setting" className={styles.small_rock} />
                </div>
            </div>
            {/* <Footer /> */}
        </>
    );
}

export default AboutUs;